import { useEffect, useRef } from "react";

const CLIENT_ID = "ca-pub-3708923200259704";

const SLOTS = {
  banner: process.env.REACT_APP_ADSENSE_SLOT_BANNER || "",
  inline: process.env.REACT_APP_ADSENSE_SLOT_INLINE || "",
  sidebar: process.env.REACT_APP_ADSENSE_SLOT_SIDEBAR || "",
};

const LAYOUTS = {
  banner: {
    heightClass: "h-24 md:h-28",
    format: "auto",
    fullWidthResponsive: true,
    style: { display: "block", width: "100%", height: "100%" },
  },
  inline: {
    heightClass: "h-64",
    format: "fluid",
    layoutKey: "-fb+5w+4e-db+86",
    style: { display: "block", width: "100%" },
  },
  sidebar: {
    heightClass: "h-[600px]",
    format: "vertical",
    fullWidthResponsive: false,
    style: { display: "inline-block", width: "300px", height: "600px" },
  },
};

/**
 * Renders a real AdSense ad unit when its slot ID env var is set,
 * otherwise renders a labelled placeholder block. The main gtag/adsbygoogle
 * loader is included once globally in public/index.html.
 */
export default function AdBlock({ variant = "banner", label = "Sponsored Content — AD", testId }) {
  const slot = SLOTS[variant];
  const layout = LAYOUTS[variant] || LAYOUTS.banner;
  const insRef = useRef(null);
  const pushedRef = useRef(false);

  useEffect(() => {
    if (!slot || pushedRef.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushedRef.current = true;
    } catch {
      /* silent — AdSense will retry on next navigation */
    }
  }, [slot]);

  // Fallback: no slot configured yet → keep the visual placeholder
  if (!slot) {
    return (
      <div
        data-testid={testId || `ad-slot-${variant}`}
        className={`ad-slot rounded-xl w-full ${layout.heightClass} flex flex-col items-center justify-center text-center relative overflow-hidden`}
      >
        <span className="font-mono-label absolute top-3 left-3 text-white/50">
          {label}
        </span>
        <span className="font-mono-label text-white/30">
          AdSense slot · {variant}
        </span>
        <span className="text-[10px] font-mono text-white/20 mt-2 tracking-wider">
          set REACT_APP_ADSENSE_SLOT_{variant.toUpperCase()} to activate
        </span>
      </div>
    );
  }

  return (
    <div
      data-testid={testId || `ad-slot-${variant}`}
      className={`rounded-xl w-full ${layout.heightClass} overflow-hidden relative`}
    >
      <ins
        ref={insRef}
        className="adsbygoogle"
        style={layout.style}
        data-ad-client={CLIENT_ID}
        data-ad-slot={slot}
        data-ad-format={layout.format}
        {...(layout.layoutKey ? { "data-ad-layout-key": layout.layoutKey } : {})}
        {...(layout.fullWidthResponsive !== undefined
          ? { "data-full-width-responsive": String(layout.fullWidthResponsive) }
          : {})}
      />
    </div>
  );
}
